import { Component, Vue } from 'vue-property-decorator';
import cnaeCodeModule from '@/store/modules/cnae-code.module'
import { CnaeCode } from '@/shared/dtos/cnae-code';
import DxDataGrid, { DxSelection, DxPaging, DxHeaderFilter, DxEditing, DxColumn, DxFilterRow, DxFilterPanel, DxExport, DxColumnChooser } from 'devextreme-vue/data-grid';



@Component({
    components: {
        DxDataGrid,
        DxSelection,
        DxPaging,
        DxHeaderFilter,
        DxEditing,
        DxColumn,
        DxFilterRow,
        DxFilterPanel,
        DxExport,
        DxColumnChooser
    },
})

export default class CnaeLista extends Vue {

    public pageSize: number = 15;
    public maxWidth: number = 500;
    public addHidden = true;
    public loading = false;
    public search = '';
    public cnaeCode: CnaeCode = new CnaeCode();

    public get cnaeCodeList() {
        return cnaeCodeModule.cnaeCodes;
    }

    public get columns() {
        return [
            { dataField: 'id', allowEditing: false },
            { dataField: 'code', caption: this.$tc('maestro-configuracion.codigo'), allowEditing: true },
            { dataField: 'description', caption: this.$tc('maestro-configuracion.descripcion'), allowEditing: true},
        ]
    }

    public mounted() {
        cnaeCodeModule.getCnaeCodes();
    }

    public rowInserted(e: any){
        cnaeCodeModule.insertarCnaeCode(e.data);
    }

    public rowUpdated(e: any){
       cnaeCodeModule.modificarCnaeCode(e.data);
    }
    
    public rowRemoved(e: any){
        cnaeCodeModule.eliminarCnaeCode(e.key);
    }

    public initNewRow(e: any){
        e.data.id = 0;
    }
}